import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/img/arrow-left.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-f0150b9a")

_pushScopeId("data-v-f0150b9a")
const _hoisted_1 = { class: "cce-wrap" }
const _hoisted_2 = { class: "cce-header flex justify-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { style: {"width":"460px"} }
const _hoisted_5 = { class: "cce-body flex justify-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, "返回后未保存信息将会丢失，是否确认退出？", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_step = _resolveComponent("a-step")
  const _component_a_steps = _resolveComponent("a-steps")
  const _component_basicInfo = _resolveComponent("basicInfo")
  const _component_unitExperiment = _resolveComponent("unitExperiment")
  const _component_scenarioConstruction = _resolveComponent("scenarioConstruction")
  const _component_gradingSystem = _resolveComponent("gradingSystem")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "cce-back",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modals.back=true))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_a_steps, {
          current: _ctx.activeStep,
          type: "navigation",
          style: _ctx.stepStyle,
          onChange: _ctx.changeStep
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step, stepIndex) => {
              return (_openBlock(), _createBlock(_component_a_step, {
                key: step.title,
                status: step.status,
                title: step.title,
                disabled: step.disabled
              }, null, 8, ["status", "title", "disabled"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["current", "style", "onChange"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      (_ctx.activeStep===0)
        ? (_openBlock(), _createBlock(_component_basicInfo, {
            key: 0,
            onNext: _ctx.handleNext
          }, null, 8, ["onNext"]))
        : (_ctx.activeStep===1)
          ? (_openBlock(), _createBlock(_component_unitExperiment, {
              key: 1,
              onNext: _ctx.handleNext
            }, null, 8, ["onNext"]))
          : (_ctx.activeStep===2)
            ? (_openBlock(), _createBlock(_component_scenarioConstruction, {
                key: 2,
                onNext: _ctx.handleNext
              }, null, 8, ["onNext"]))
            : (_openBlock(), _createBlock(_component_gradingSystem, {
                key: 3,
                onNext: _ctx.handleNext
              }, null, 8, ["onNext"]))
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.modals.back,
      onOnOk: _ctx.modalBackConfirm,
      onOnCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modals.back=false))
    }, {
      content: _withId(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["visible", "onOnOk"])
  ]))
})